window.Support = {
	
	initPrefs : function(formid){

		$('#prefsMenu').height($('#contentDiv').outerHeight());
		var options = {
			success:function(data){Support.prefsCallback(formid, data);},
			dataType:"json"
		};
		MyForm.prepare(formid, "support_prefs", options, true);
		MyFacture.customForm();


		if(formid == 'prefsGeneralForm') {
			// init select for timetracking
			var staffs = $('#staffsAutoTimetrackingRaw').val();
			if(staffs == '' || (typeof staffs == 'undefined')) {
				staffs = '[]';
			}
			staffs = JSON.parse(staffs);
			$('#pref_staffsAutoTimetracking').find('option').each(function(i, element) {
				if(Utils.in_array($(element).attr('value'), staffs)) {
					$(element).attr('selected', 'selected');
				}
			});
			$('#pref_staffsAutoTimetracking').multipleSelect('refresh');
		}

		$('#pref_fromName').change(function(){
			if($(this).val() === 'custom'){
				$('.fromNameInput:hidden').show();
			}else{
				$('.fromNameInput:visible').hide();
			}
		});

		$('#pref_signatureType').change(function(){
			if($(this).val() === 'custom'){
				$('.signature-support:hidden').show();
			}else{
				$('.signature-support:visible').hide();
			}
		});

		$('#pref_hasAutoResponder').change(function(){
			if($(this).is(':checked')){
				$('.autoresponse-support:hidden').show();
			}else{
				$('.autoresponse-support:visible').hide();
			}
		});

		
		$('#pref_fromEmail').change(function(){
			if($(this).val() === 'custom'){
				$('#pref_fromEmailNylas:visible').hide();
				$('#pref_fromEmailCustom:hidden').show();
			} else if($(this).val() === 'nylas') {
				$('#pref_fromEmailNylas:hidden').show();
				$('#pref_fromEmailCustom:visible').hide();
			} else {
				$('#pref_fromEmailNylas:visible').hide();
				$('#pref_fromEmailCustom:visible').hide();
			}
		});

		$('#pref_autoResponderEmailType').change(function() {
			if($(this).val() === 'custom') {
				$('#pref_autoResponderNylas').hide();
				$('#pref_autoResponderEmail').show();
			} else {
				$('#pref_autoResponderNylas').show();
				$('#pref_autoResponderEmail').hide();
			}
		});
		$('#pref_hasAutoResponder').on('click', function() {
			$('#pref_autoResponderEmailType').trigger('change');
		});

		$('#pref_fromName, #pref_signatureType, #pref_hasAutoResponder, #pref_fromEmail, #pref_autoResponderEmailType').trigger('change');
	},
			
	prefsCallback : function(formid, data){
		var formIsOk = MyForm.processJson(data, formid);
		if(formIsOk){
			MyWindow.alert(Loc.g('Vos informations ont bien été mises à jour'), {type: 'confirm'});
		}
		else
		{
			if(data.form.msg) {
				MyWindow.alert(data.form.msg, {type: 'error'});
			} else {
				MyWindow.alert(Loc.g('Une erreur est survenue !'), {type: 'error'});
			}
		}
	},
		
	editSupportTemplate : function(setid){
		var	options = {
				title	: Loc.g("Modification du modèle d'email"),
				buttons	: [
					{
						text : Loc.g("Annuler"),
						click : function() {$(this).dialog("close");}
					},
                    {
                        text : Loc.g("Enregistrer"),
                        click : function() {$('#templateForm').submit();}
                    },
                ],
				width : 850,
				callback : function(data){
					var formId = "templateForm";
					var options = {	success:function(data){
												Support.recordSupportTemplateCallback(data);
											}, 
									dataType:"json"};
						
					MyForm.prepare(formId, "support_prefs&action=templateRecord", options, true);
					MyFacture.customForm();
				}
			};
		
		MyWindow.load("support_prefs", {action:"templateForm", setid : setid}, options );
	},
	
	recordSupportTemplateCallback : function(data){
		var formIsOk = MyForm.processJson(data, "templateForm");
		if(formIsOk){
			Utils.relocate("./?_f=support_prefs&action=templates&setid="+data.setid);
		}
	},
			
	deleteSupportTemplate : function(setid){
		var	options = {
			title	: Loc.g("Suppression du modèle"),
			type : 'warning',
			buttons	: [
				{text : Loc.g("Oui"),click : function() {
						MyFacture.post('support_prefs', {action:"templateDelete", setid : setid}, function(data){
							Utils.reload();
						});
					}},
				{text : Loc.g("Non"),click : function() {$(this).dialog("close");}}]
		};

		MyWindow.alert(Loc.g("Voulez-vous supprimer ce modèle d'email"), options);

	},
			
	injectTemplate : function(){
		var idtpl = $('select[name=email_template]').val();
		if(idtpl !== ""){
			var message = $('#templateTexts_'+idtpl).find('div.message').html();
			$("#conv_message").redactor("set", message);
			$("#conv_message").redactor("sync");
		}
	},
	
	massUpdateStatus: function(ids){
		var optionsPopup = {
			title	: Loc.g('Changer le statut des tickets'),
			width: 440,
			buttons	: [
				{
					text : Loc.g("Fermer"), 
					click : function(){$(this).dialog("close");}
				},
				{
					text: Loc.g("Valider"),
					click: function () {
						var popup = $(this);
						var step = $("#tickets_step").val();

						MyFacture.post('support_tickets', { action: "recordSteps", ids: ids, step: step }, function (data) {
							if (data.error == '0') {
								Listing.update('ticketsListing');
								$('#groupedActionContainer').hide();
								$('.listingTools').show();
								popup.dialog("close");
							}
							else {
								$("#msgError").removeClass("alert-info");
								$("#msgError").addClass("alert-danger");
								$("#msgError").html(data.msg);
							}
						}, "json");
					}
				}
			],
		};
		
		MyWindow.load("support_tickets", {
			action	: "massUpdateStepsForm"
		}, optionsPopup);
	},

    massUpdateStaff: function(ids){
        var optionsPopup = {
            title	: Loc.g('Changer l\'assignation des tickets'),
            width: 440,
            buttons	: [
                {
                    text: Loc.g("Fermer"),
                    click: function () {
                        $(this).dialog("close");
                    }
                },
                {
                    text : Loc.g("Valider"), 
                    click : function(btn) {
                        var popup = $(this);
                        var staff = $("#tickets_staff").val();

                        MyForm.toggleDisabledForm({
                            btn : $(btn.currentTarget),
                            dataToCheckOnBody : 'ticketsMassUpdateStaffForm',
                            isPopup : true,
                        });

                        MyFacture.post('support_tickets', {
                            action:"recordStaffs", 
                            ids : ids, 
                            staff:staff
                        }, function(data){

                            MyWindow.awake('popupWindow');

                            if(data.error == '0') {

                                Listing.update('ticketsListing');
                                $('#groupedActionContainer').hide();
                                $('.listingTools').show();
                                popup.dialog("close");

                            } else {
                                
                                $("#msgError").removeClass("alert-info").addClass("alert-danger").html(data.msg);

                            }

                        },"json");
                    }
                },
            ],
        };
		
		MyWindow.load("support_tickets", {
			action	: "massUpdateStaffsForm"
		}, optionsPopup);
	},
	
	massAddTag: function(ids){
		var optionsPopup = {
			title	: Loc.g('Ajouter des Smart Tags aux tickets'),
			width: 380,
			buttons	: [
				{text : Loc.g("Valider"), click : 
					function(){
						
						var popup = $(this);
						
						var tags = $("#tickets_tags").val();
						
						MyFacture.post('support_tickets', {action:"recordTags", ids : ids, tags:tags}, function(data){
							if(data.error == '0') {
								
								Listing.update('ticketsListing');
								$('#groupedActionContainer').hide();
								$('.listingTools').show();
								popup.dialog("close");
								
							}else {
								
								$("#msgError").removeClass("alert-info");
								$("#msgError").addClass("alert-danger");
								$("#msgError").html(data.msg);
							}

						},"json");
					}
				},
				{text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}}
			],
			callback : function() {
				MyFacture.customForm();
			}
		};
		
		MyWindow.load("support_tickets", {
			action	: "massUpdateTagsForm"
		}, optionsPopup);
	},

	groupTicketsNew: function(type, ids) {

		var formId = "ticketsGroupForm";

		var isGroupForm = type == "group";

		var optionsPopup = {
			title	: type == "group" ? Loc.g("Modifier le groupe") : Loc.g('Grouper des tickets'),
			width: 500,
			buttons	: [
				{text : Loc.g("Fermer"), click :
					function(){
						$(this).dialog("close");
					}
				},
				{text : Loc.g("Valider"), click :
					function(){
						$('#'+formId).submit();
					}
				},			],
			callback : function(data) {

				var options = {
					success:function(data){
						var formIsOk = MyForm.processJson(data, formId);
						if(formIsOk){
							Support.groupTicketsCallback(data);
						}
					},
					dataType:"json"
				};

				MyForm.prepare(formId, "support_tickets&action=ticketsGroupRecord", options, true);
				MyFacture.customForm();
			}
		};

		MyWindow.load("support_tickets", {
			action	: "groupTicketsForm",
			ids		: ids
		}, optionsPopup);

	},

	groupTickets: function(ids) {

		var formId = "ticketsGroupForm";

		var optionsPopup = {
			title	: Loc.g('Grouper des tickets'),
			width: 500,
			buttons	: [
				{text : Loc.g("Fermer"), click :
					function(){
						$(this).dialog("close");
					}
				},
				{text : Loc.g("Valider"), click :
					function(){
						$('#'+formId).submit();
					}
				}
			],
			callback : function(data) {

				var options = {
					success:function(data){
						var formIsOk = MyForm.processJson(data, formId);
						if(formIsOk){
							Support.groupTicketsCallback(data);
						}
					},
					dataType:"json"
				};

				MyForm.prepare(formId, "support_tickets&action=ticketsGroupRecord", options, true);
				MyFacture.customForm();
			}
		};

		MyWindow.load("support_tickets", {
			action	: "groupTicketsForm",
			ids		: ids
		}, optionsPopup);

	},

	groupEdit : function(groupId){

		var formId = "ticketsGroupForm";

		var options = {
			title	: Loc.g("Modifier le groupe"),
			width : 500,
			buttons	: [
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"), 
					click : function(btn){
						$('#'+formId).submit();
					}
				}
			],
			callback	: function(data){

				var options = {
					success:function(data){
						var formIsOk = MyForm.processJson(data, formId);
						if(formIsOk){
							$('#'+formId).parent().dialog("close");
							Listing.update($('#listingname').val());
						}
					},
					dataType:"json"
				};

				MyForm.prepare(formId, "support_tickets&action=ticketsGroupRecord", options, true);

			}
		};
				
		var params = {
			action:		"groupTicketsForm",
			groupid:	groupId
		};

		MyWindow.load("support_tickets", params, options);

	},

	groupTicketsCallback: function(data) {
		var formIsOk = MyForm.processJson(data, "ticketsGroupForm");
		if(formIsOk){
			Utils.reload();
		}
	},
	
	displayTicketsGroup: function(groupid) {
		
		var optionsPopup = {
			title	: Loc.g('Liste des tickets du groupe'),
			width: 800,
			buttons	: [
				{text : Loc.g("Fermer"), click : 
					function(){
						$(this).dialog("close");
					}
				}
			]
		};
		
		MyWindow.load("support_tickets", {
			action	: "listTicketsForGroup",
			groupid	: groupid
		}, optionsPopup);
	},
	
	removeFromGroup : function(groupid, ticketid) {
		
		var	options = {
			title	: Loc.g("Suppression du groupe"),
			type : 'warning',
			buttons	: [
				{
					text : Loc.g("Non"),
					click : function() {
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"),
					click : function() {
						MyFacture.post(
							'support_ticket', 
							{action:"removeFromGroup", groupid : groupid, ticketid:ticketid}, 
							function(data){
								Utils.reload();
							}
						);
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Voulez-vous retirer ce ticket du groupe ?"), options);
		
	},
	
	deleteGroup : function(groupid) {
		
		var	options = {
			title	: Loc.g("Suppression du groupe"),
			type : 'warning',
			buttons	: [
				{
					text : Loc.g("Non"),
					click : function() {
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"),
					click : function() {
						MyFacture.post(
							'support_groups', 
							{action:"deleteGroup", groupid : groupid}, 
							function(data){
								Utils.reload();
							}
						);
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Voulez-vous supprimer ce groupe ?"), options);
	},
	
	setTicketsLintingOnGroup : function(groupid) {
		
		MyFacture.post(
			'support_tickets', 
			{action:"setTicketsLintingOnGroup", groupid : groupid}, 
			function(data){
				Utils.relocate("?_f=support_tickets");
			}
		);
	},
	
	activateTimetracking: function() {
		if($('#pref_activateTimetracking').prop('checked')) {
			// show service chooser =) (+ customForm it !)
			$('div.timetracking-service').show();
			MyFacture.customForm($('div.timetracking-service'));
		} else {
			// hide it ;)
			$('div.timetracking-service').hide();
		}
	}
}; 